const hasTextNodes = (element) => {
  const children = element.childNodes;
  for (let i = 0; i < children.length; i++) {
    const child = children[i];
    if (child.nodeType === Node.TEXT_NODE && child.textContent.trim() !== "") {
      return true;
    }
  }
  return false;
};

export { hasTextNodes };
